<template>
  <section>
    <div class="row">
      <div class="col-12">
        <div class="card" v-if="!loaded || (loaded && !data)">
          <p class="text-center" v-if="!loaded && !data">
            <i class="fa fa-refresh fa-spin mr-2"></i> Carregando...
          </p>
          <div class="text-center" v-if="loaded && !data">
            Não foi possível carregar os resultados.
            <div class="text-center">
              <button class="btn btn-white btn-small" v-on:click="fetch()">
                <i class="fa fa-refresh mr-2 color-primary"></i>
                <span>Tentar Novamente</span>
              </button>
            </div>
          </div>
        </div>

        <div class="home-results__blocks" v-if="loaded && data">
          <nav class="home-results__nav">
            <ul>
              <li
                v-for="(item, index) in data"
                :key="`home-results__nav-${index}`"
              >
                <button
                  type="button"
                  class="btn btn-white btn-square"
                  v-text="item.lottery.name"
                  v-on:click="setSelected(item)"
                  v-bind:class="[
                    { 'is-active': selected === item },
                    item.lottery.slug,
                  ]"
                ></button>
              </li>
            </ul>
          </nav>
          <div>
            <div class="home-results__card__wrap">
              <div
                class="card home-results__card"
                v-if="selected"
                v-bind:class="['lot-' + selected.lottery.slug]"
              >
                <div class="card-head lot-bg">
                  <div class="d-lg-none">
                    Sorteio <strong v-text="selected.drawDateText"></strong> •
                    Concurso <strong v-text="selected.drawNumber"></strong>
                  </div>

                  <div class="d-none d-lg-block">
                    Sorteio <strong v-text="selected.drawDateText"></strong> •
                    Concurso <strong v-text="selected.drawNumber"></strong> •
                    <strong v-text="selected.estimatedPrizeText"></strong>
                  </div>
                </div>

                <div class="card-content">
                  <div
                    class="result__content__wrap pt-4 pl-4 pr-4"
                    v-bind:class="[
                      'result__content__wrap--' + selected.lottery.gameType,
                    ]"
                  >
                    <div
                      v-for="(
                        drawResult, indexDrawResult
                      ) in selected.drawResults"
                      :key="`home-result-card-${indexDrawResult}`"
                    >
                      <div
                        class="home-result__card__result home-result__card__result--tens"
                        v-if="selected.lottery.gameType === 'tens'"
                      >
                        <div
                          class="lot-color text-center"
                          v-if="selected.lottery.slug == 'dupla-sena'"
                        >
                          <strong
                            v-text="drawResult.raffleNumber + ' º Sorteio'"
                          ></strong>
                        </div>

                        <div
                          class="result__tens-grid"
                          v-if="
                            (indexDrawResult === 0 &&
                              (selected.lottery.slug === 'timemania' ||
                                selected.lottery.slug === 'dia-de-sorte' ||
                                selected.lottery.slug === 'mais-milionaria')) ||
                            !selected.lottery.hasKey !==
                              (selected.lottery.slug === 'timemania' ||
                                selected.lottery.slug === 'dia-de-sorte' ||
                                selected.lottery.slug === 'mais-milionaria')
                          "
                        >
                          <div
                            class="lot-bg-light"
                            v-for="ten in drawResult.resultFormatted"
                            :key="`ten-${ten}`"
                          >
                            <span v-text="ten"></span>
                          </div>
                        </div>

                        <div
                          class="text-center"
                          v-if="
                            indexDrawResult === 1 &&
                            selected.lottery.slug === 'mais-milionaria'
                          "
                        >
                          <div class="result__trevo-grid lot-bg-light">
                            <img src="/media/trevo.svg" alt="Trevo" />
                            <div
                              v-for="ten in drawResult.resultFormatted"
                              :key="`ten-mais-milionaria-${ten}`"
                            >
                              <span>{{ ten }}</span>
                            </div>
                          </div>
                        </div>

                        <div
                          class="text-center"
                          v-if="
                            indexDrawResult === 1 &&
                            (selected.lottery.slug === 'timemania' ||
                              selected.lottery.slug === 'dia-de-sorte')
                          "
                        >
                          <div class="result__tens-key lot-bg-light">
                            <i
                              class="fa"
                              v-bind:class="{
                                'fa-heart':
                                  selected.lottery.slug === 'timemania',
                                'fa-calendar':
                                  selected.lottery.slug === 'dia-de-sorte',
                              }"
                            ></i>
                            <strong v-text="drawResult.result"></strong>
                          </div>
                        </div>
                        <!-- /result tens -->
                      </div>

                      <div
                        class="home-result__card__result home-result__card__result--federal"
                        v-if="selected.lottery.gameType === 'federal'"
                      >
                        <div class="result__federal-item">
                          <div class="result__federal-item__title text-center">
                            <strong
                              class="lot-color"
                              v-text="drawResult.raffleNumber + 'º'"
                            ></strong>
                          </div>
                          <div
                            class="result__federal-item__val lot-bg"
                            v-text="drawResult.result"
                          ></div>
                        </div>
                      </div>

                      <div
                        class="home-result__card__result home-result__card__result--loteca"
                        v-if="selected.lottery.gameType === 'loteca'"
                      >
                        <div
                          class="result__loteca-item"
                          v-for="(itemLoteca, index) in selected.footballScheme
                            .matchList"
                          :key="`matchlist-${index}`"
                        >
                          <div class="lot-color">
                            <strong v-text="index + 1"></strong>
                          </div>
                          <div>
                            <span v-text="itemLoteca.homeTeam || ''"></span>
                          </div>
                          <div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg': itemLoteca.colIndex === 0,
                                }"
                              >
                                <span v-text="itemLoteca.homeGoals || 0"></span>
                              </div>
                            </div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg': itemLoteca.colIndex === 1,
                                }"
                              >
                                <span>x</span>
                              </div>
                            </div>
                            <div>
                              <div
                                class="result__loteca-item__option"
                                v-bind:class="{
                                  'lot-bg': itemLoteca.colIndex === 2,
                                }"
                              >
                                <span v-text="itemLoteca.awayGoals || 0"></span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <span v-text="itemLoteca.awayTeam || ''"></span>
                          </div>
                        </div>
                        <!-- /result loteca -->
                      </div>

                      <div
                        class="home-result__card__result home-result__card__result--supersete"
                        v-if="selected.lottery.gameType === 'supersete'"
                      >
                        <div class="result__supersete-grid">
                          <div
                            v-for="(column, index) in Object.values(
                              drawResult.resultFormatted
                            )"
                            class="result__supersete-grid__column"
                            :key="`drawresult-supersete-${index}`"
                          >
                            <div
                              class="result__supersete-grid__column-title lot-color"
                            >
                              <span v-text="index + 1"></span>
                            </div>
                            <div class="result__supersete-grid__column-items">
                              <div
                                v-for="number in column"
                                class="lot-bg-light"
                                :key="`supersete-column-${number}`"
                              >
                                <span v-text="number"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- /result supersete -->
                      </div>

                      <p
                        v-if="
                          selected.wasAccumulated &&
                          (!selected.lottery.hasKey ||
                            drawResult.raffleNumber ===
                              selected.drawResults.length)
                        "
                        class="text-center text-uppercase color-primary"
                      >
                        <strong
                          v-if="
                            indexDrawResult === 0 &&
                            selected.lottery.slug !== 'dia-de-sorte' &&
                            selected.lottery.slug !== 'timemania' &&
                            selected.lottery.slug !== 'mais-milionaria' &&
                            selected.lottery.slug !== 'dupla-sena'
                          "
                          >Acumulou!</strong
                        >
                        <strong v-if="indexDrawResult === 1">Acumulou!</strong>
                      </p>

                      <table
                        class="result__table-prize"
                        v-if="
                          drawResult.drawPrizes &&
                          drawResult.drawPrizes.length &&
                          selected.lottery.slug === 'dupla-sena'
                        "
                      >
                        <tr>
                          <td class="text-center">
                            <strong>Premiação</strong>
                          </td>
                          <td class="text-center">
                            <strong>Ganhadores</strong>
                          </td>
                          <td class="text-center"><strong>Prêmio</strong></td>
                        </tr>

                        <tr
                          v-for="(a, index) in drawResult.drawPrizes"
                          :key="`prize-level-${index}`"
                        >
                          <td class="text-center">
                            <span v-text="a.prizeLevelName"></span>
                          </td>
                          <td class="text-center">
                            <span
                              v-text="a.winners === 0 ? '-' : a.winners"
                            ></span>
                          </td>
                          <td class="text-center">
                            <span
                              v-text="a.prize === 0 ? '-' : a.prizeText"
                            ></span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <p
                    class="d-lg-none text-center text-uppercase lot-color home-result__card__result__prize"
                    v-if="selected.estimatedPrize"
                  >
                    <strong
                      v-text="'R$ ' + selected.estimatedPrizeText"
                    ></strong>
                  </p>

                  <div
                    v-if="
                      selected.lottery.slug !== 'dupla-sena' &&
                      selected.lottery.slug !== 'loteria-federal' &&
                      selected.drawResults &&
                      selected.drawResults.length
                    "
                  >
                    <table
                      class="result__table-prize"
                      v-for="(
                        drawResult, drawResultIndex
                      ) in selected.drawResults"
                      :key="`result-table-prize-${drawResultIndex}`"
                    >
                      <tr
                        v-if="
                          drawResult.drawPrizes && drawResult.drawPrizes.length
                        "
                      >
                        <td class="text-center"><strong>Premiação</strong></td>
                        <td class="text-center"><strong>Ganhadores</strong></td>
                        <td class="text-center"><strong>Prêmio</strong></td>
                      </tr>

                      <tr
                        v-for="(
                          drawPrize, drawPrizeIndex
                        ) in drawResult.drawPrizes"
                        :key="`draw-prize-${drawPrizeIndex}`"
                      >
                        <td class="text-center">
                          <span v-text="drawPrize.prizeLevelName"></span>
                        </td>
                        <td class="text-center">
                          <span
                            v-text="
                              drawPrize.winners === 0 ? '-' : drawPrize.winners
                            "
                          ></span>
                        </td>
                        <td class="text-center">
                          <span
                            v-text="
                              drawPrize.prize === 0 ? '-' : drawPrize.prizeText
                            "
                          ></span>
                        </td>
                      </tr>
                    </table>
                    <!-- /.result__table-prize -->

                    <table
                      class="result__table-prize"
                      v-if="
                        selected.lottery.slug === 'loteria-federal' &&
                        selected.drawResults &&
                        selected.drawResults.length
                      "
                    >
                      <tr>
                        <td class="text-center"><strong>Premiação</strong></td>
                        <td class="text-center"><strong>Ganhadores</strong></td>
                        <td class="text-center"><strong>Prêmio</strong></td>
                      </tr>

                      <tbody
                        v-for="(
                          drawResult, drawResultIndex
                        ) in selected.drawResults"
                        :key="`draw-result-${drawResultIndex}`"
                      >
                        <tr
                          v-for="(
                            drawPrize, drawPrizeIndex
                          ) in drawResult.drawPrizes.filter(
                            (a) => a.prizeLevel !== 1
                          )"
                          :key="`draw-result-prize-${drawPrizeIndex}`"
                        >
                          <td class="text-center">
                            <span v-text="drawPrize.prizeLevelName"></span>
                          </td>
                          <td class="text-center">
                            <span
                              v-text="
                                drawPrize.winners === 0
                                  ? '-'
                                  : drawPrize.winners
                              "
                            ></span>
                          </td>
                          <td class="text-center">
                            <span
                              v-text="drawPrize.prize === 0 ? '-' : a.prizeText"
                            ></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- /.result__table-prize:federal -->
                  </div>
                </div>

                <div class="card-foot">
                  <a
                    v-bind:href="
                      '/' +
                      selected.lottery.slug +
                      '/resultados/' +
                      selected.drawNumber
                    "
                    class="btn btn-lot btn-invert btn-square btn-block text-uppercase mb-3"
                    ><strong>Ver Detalhes do Sorteio</strong></a
                  >
                  <a
                    v-bind:href="'/' + selected.lottery.slug"
                    class="btn btn-lot btn-square btn-block text-uppercase"
                    >Aposte no Próximo Concurso</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="home-results__banner-wrap">
              <h1></h1>
              <!-- Desktop -->
              <!-- <template v-for="bannerList in [bannerFirstTime]">
                <a
                  v-for="(banner, index) in bannerList"
                  :key="`banner-desktop-${index}`"
                  :href="banner.link"
                  class='d-none d-md-block'
                  target="_blank"
                >
                  <img
                    :src="banner.image"
                    :alt="banner.alt"
                    :title="banner.title"
                    class="img-fluid"
                  />
                </a>

              </template> -->
              <!-- Mobile -->
              <!-- <template v-for="bannerList in [bannerMobileFirstTime]">
                <a
                  v-for="(banner, index) in bannerList"
                  :key="`banner-desktop-${index}`"
                  :href="banner.link"
                  class="d-md-none"
                  target="_blank"
                >
                  <img
                    :src="banner.image"
                    :alt="banner.alt"
                    :title="banner.title"
                    class="img-fluid"
                  />
                </a>

              </template> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style src="./ResultsInPage.scss" scoped></style>
<script>
import getBannerById from '@services/content/getBannerById';

export default {
  data: function () {
    return {
      loaded: false,
      selected: null,
      data: null,
      bannerFirstTime: [],
      bannerMobileFirstTime: [],
      bannerTeleSena: [],
      bannerMobileTeleSena: []
    };
  },

  methods: {
    fetch: function () {
      this.data = null;
      this.loaded = false;

      this.$http
        .get('/rest/last-results')
        .then((res) => {
          if (res && res.data) {
            this.data = res.data.filter((lottery) => lottery.lotteryID !== 13);
            this.setSelected(this.data[0]);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .then(() => {
          this.loaded = true;
        });
      this.loadBanners();
    },
    async loadBanners () {
      const [firstTime, firstTimeMob, telesena, telesenaMob] = await Promise.all([
        getBannerById(39, { limit: 1 }),
        getBannerById(40, { limit: 1 }),
        getBannerById(41, { limit: 1 }),
        getBannerById(42, { limit: 1 })
      ]);

      this.bannerFirstTime = firstTime;
      this.bannerMobileFirstTime = firstTimeMob;
      this.bannerTeleSena = telesena;
      this.bannerMobileTeleSena = telesenaMob;
    },
    setSelected: function (item) {
      this.selected = item;
    }
  },
  created: function () {
    this.fetch();
  }
};
</script>
